export const INIT_SUCCESS = 'INIT_SUCCESS';
export const SET_SORT_ORDER = 'SET_SORT_ORDER';
export const ADD_DEPARTURE_MONTH_FILTER = 'ADD_DEPARTURE_MONTH_FILTER';
export const REMOVE_DEPARTURE_MONTH_FILTER = 'REMOVE_DEPARTURE_MONTH_FILTER';
export const ADD_DEPARTURE_AIRPORT_FILTER = 'ADD_DEPARTURE_AIRPORT_FILTER';
export const REMOVE_DEPARTURE_AIRPORT_FILTER = 'REMOVE_DEPARTURE_AIRPORT_FILTER';
export const SET_MAX_PRICE_FILTER = 'SET_MAX_PRICE_FILTER';
export const REMOVE_MAX_PRICE_FILTER = 'REMOVE_MAX_PRICE_FILTER';
export const ADD_DESTINATION_FILTER = 'ADD_DESTINATION_FILTER';
export const REMOVE_DESTINATION_FILTER = 'REMOVE_DESTINATION_FILTER';
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS';
